// extracted by mini-css-extract-plugin
export default {"scroll_to_top":"ScrollToTopButton_scroll_to_top__45Y+y"};